import { queryOptions, useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import { QueryConfig } from '@/lib/react-query'

export type AccountWithDuplicateSubscriptions = {
    accountId: string
    name: string
    email: string
    phone: string
    city: string | null
    state: string | null
    isDisabled: boolean
    accountScopeSubscriptionCount: number
    storeScopeSubscriptionCount: number
}

export const getAccountsWithDuplicateSubscriptions = (): Promise<AccountWithDuplicateSubscriptions[]> => {
    return api.get('/v2/subscription-reports/accounts-with-duplicate-subscriptions')
}

export const getAccountsWithDuplicateSubscriptionsQueryOptions = () => {
    return queryOptions({
        queryKey: ['subscription-reports', 'accounts-with-duplicate-subscriptions'],
        queryFn: () => getAccountsWithDuplicateSubscriptions(),
    })
}

type UseAccountsWithDuplicateSubscriptionsOptions = {
    queryConfig?: QueryConfig<typeof getAccountsWithDuplicateSubscriptions>
}

export const useAccountsWithDuplicateSubscriptions = ({ queryConfig }: UseAccountsWithDuplicateSubscriptionsOptions = {}) => {
    return useQuery({
        ...getAccountsWithDuplicateSubscriptionsQueryOptions(),
        ...queryConfig,
    })
}

